import { cn, Icon, Typography } from "@kyan/ui";

import { copy } from "#/utils/copy";
import { truncateMiddle } from "#/utils/string.utils";

export interface ReferralFieldProps {
  value: string;
  disabled: boolean;
  isLink?: boolean;
}

export const ReferralField: React.FC<ReferralFieldProps> = ({
  value,
  disabled,
  isLink = true,
}) => {
  const handleCopy = () => {
    copy(value);
  };

  return (
    <div
      className={cn(
        "border-divider flex h-11 flex-1 items-center rounded-sm border sm:flex-none",
        {
          "opacity-50": disabled,
          "sm:w-62": isLink,
          "sm:w-50": !isLink,
        },
      )}
    >
      <div className="flex flex-1 flex-col px-3">
        <Typography size={10}>Referral {isLink ? "link" : "code"}</Typography>
        <Typography primary size={12} className="w-20 truncate sm:w-auto">
          {truncateMiddle(value, 13)}
        </Typography>
      </div>

      <button
        disabled={disabled}
        className={cn(
          "border-divider h-full rounded-r-sm border-l px-4 transition-colors",
          {
            "hover:bg-buttonHover cursor-pointer": !disabled,
            "cursor-not-allowed": disabled,
          },
        )}
        onClick={handleCopy}
      >
        <Icon size="sm" name="copy" />
      </button>
    </div>
  );
};
